import { get } from 'lodash';
import { convertHexToRGB } from '../../utils';

const styles = (theme) => ({
  root: {
    width: '90%',
    marginTop: 10,
    color: get(theme, 'color.bodyText'),
    padding: '3rem',
  },
  formSection: {
    width: "35%",
    backgroundColor: get(theme, 'color.white'),
    padding: "48px",
    paddingTop: "36px",
    border: `1px solid ${get(theme, 'color.borderColor')}`,
  },
  flex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  fieldContainer: {
    marginTop: "-1rem",
  },
  orgNameFieldContainer: {
    marginTop: "-5px",
  },
  alertContainer: {
    top: "14px",
  },
  imgLogo: {
    '& img': {
      maxWidth: '99px',
      maxHeight: '99px',
    },
  },
  alternateLogo: {
    marginBottom: 0,
  },
  submitButton: {
    textTransform: 'none',
    color: get(theme, 'color.primaryButtonText'),
    backgroundColor: get(theme, 'color.primaryButtonBackground'),
    borderColor: get(theme, 'color.primaryButtonBackground'),
    width: "100%",
    '&:focus': {
      outlineWidth: '0.3px !important',
      outlineOffset: '-2.1px !important',
      outlineStyle: 'solid !important',
      outlineRadius: '3px !important',
    },
  },
  cancelButton: {
    textTransform: 'none',
    color: get(theme, 'color.primaryButtonBackground'),
    borderColor: get(theme, 'color.primaryButtonBackground'),
    width: "100%",
    marginTop: "1rem",
    '&:focus': {
      border: `3px double ${get(theme, 'color.primaryButtonBackground')}`,
    },
  },
  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  textError: {
    color: `${get(theme, 'color.error')} !important`,
    fontFamily: `${get(theme, 'typography.smallText')} !important`,
    fontSize: `${get(theme, 'fontSize.smallText')} !important`,
  },
  loaderContainer: {
    position: "absolute",
    top: "50",
    left: "50",
    zIndex: "10000",
  },
  textCenter: {
    textAlign: "center",
  },
  circularProgress: {
    color: get(theme, 'color.black'),
  },
  formFieldContainer: {
    marginTop: "-0.5rem",
  },
  textAreaContainer: {
    padding: '10px',
    width: '95%',
    display: "block",
    marginTop: "0.3rem",
    borderRadius: "5px",
    fontSize: "0.9rem",
    color: `${get(theme, 'color.smallText')} !important`,
    fontFamily: `${get(theme, 'typography.smallText')} !important`,
    borderColor: convertHexToRGB(get(theme, 'color.primaryButtonBackground'), 0.4),
    '&:hover': {
      borderColor: get(theme, 'color.primaryButtonHover'),
    },
    '&:focus': {
      borderColor: get(theme, 'color.primaryButtonBackground'),
      outline: `1.3px solid ${get(theme, 'color.primaryButtonBackground')}`,
    },
  },
  signupContainer: {
    marginTop: "0.9rem",
  },
  titleRegister: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    marginTop: "0.4rem",
    marginLeft: "-0.6rem",
  },
  textFieldSmall: {
    position: "relative",
    '& input': {
      height: "36px !important",
    },
  },
  requiredField: {
    position: "absolute",
    top: "0",
    left: "38px",
  },
  confirmRequiredField: {
    position: "absolute",
    top: "0",
    left: "94px",
  },
  captchaTitle: {
    fontSize: "1.3rem",
    fontWeight: "bold",
  },
  sliderField: {
    appearance: "none",
    backgroundColor: get(theme, 'color.disabledBackground'),
    width: "99%",
    height: "40px",
    padding: "0",
    borderRadius: "3px",
    '&::-webkit-slider-thumb': {
      '-moz-appearance': "none !important",
      appearance: "none !important",
      position: "relative",
      height: "47px",
      width: "137px",
      background: "transparent",
      cursor: "pointer",
      zIndex: "2",
    },
    '&::-moz-range-thumb': {
      '-moz-appearance': "none !important",
      appearance: "none !important",
      position: "relative",
      height: "20px",
      width: "100px",
      background: "transparent",
      cursor: "pointer",
      zIndex: "2",
    },
    '&:focus': {
      outline: "0!important",
      border: "0!important",
    },
  },
  rangeText: {
    position: "absolute",
    top: "1px",
    left: "2px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: get(theme, 'color.primaryButtonBackground'),
    textAlign: "center",
    height: "25px",
    width: "120px",
    transform: "translate(0, 2px)",
    color: get(theme, 'color.primaryButtonText'),
    borderRadius: "3px",
    padding: "0.4rem",
    pointerEvents: "none",
    userSelect: "none",
  },
  focused: {
    "&$focused": {
      outlineWidth: '0.3px !important',
      outlineOffset: '-2.1px !important',
      outlineStyle: 'solid !important',
      outlineRadius: '3px !important',
    },
  },
  disableSlider: {
    backgroundColor: get(theme, 'color.disabledText'),
    transition: "all 0s ease-in-out",
    cursor: "no-drop !important",
    "&$focused": {
      outlineWidth: '0 !important',
      outlineOffset: ' !important',
      outlineStyle: '0 !important',
      outlineRadius: '0 !important',
    },
  },
  sliderContainer: {
    position: "relative",
  },
  orgDescTitle: {
    fontWeight: "bold",
  },
  orgDescOpt: {
    opacity: 0.5,
    fontWeight: "bold",
  },
  orgDescHelpText: {
    color: `${get(theme, 'color.smallText')} !important`,
    fontFamily: `${get(theme, 'typography.smallText')} !important`,
    fontSize: `${get(theme, 'fontSize.smallText')} !important`,
  },
})
export default styles;